module.exports = __webpack_public_path__ + "img/sucessTick.fcfe81eb.svg";